import React from 'react';

import { Route, Switch } from 'react-router-dom';

import { Insurance as InsuranceRoutes } from 'constants/routes';

import { CreateNew } from './components/CreateNew/CreateNew';
import { Drivers } from './components/Drivers/Drivers';
import { ErrorPage } from './components/ErrorPage/ErrorPage';
import { InsuranceProducts } from './components/InsuranceProducts/InsuranceProducts';
import { InsurancePrograms } from './components/InsurancePrograms/InsurancePrograms';
import { Payment } from './components/Payment/Payment';
import { Policyholder } from './components/Policyholder/Policyholder';
import { Underwriting } from './components/Underwriting/Underwriting';
import { VehicleInformation } from './components/VehicleInformation/VehicleInformation';
import { useInsurancePresenter } from './Insurance.presenter';

const { ROUTES, ROUTE_NAMES } = InsuranceRoutes;

export const Insurance = () => {
  const { error } = useInsurancePresenter();

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <Switch>
      <Route {...ROUTES[ROUTE_NAMES.CREATE_NEW]}>
        <CreateNew />
      </Route>
      <Route {...ROUTES[ROUTE_NAMES.DRIVERS]}>
        <Drivers />
      </Route>
      <Route {...ROUTES[ROUTE_NAMES.INSURANCE_PRODUCTS]}>
        <InsuranceProducts />
      </Route>
      <Route {...ROUTES[ROUTE_NAMES.INSURANCE_PROGRAMS]}>
        <InsurancePrograms />
      </Route>
      <Route {...ROUTES[ROUTE_NAMES.PAYMENT]}>
        <Payment />
      </Route>
      <Route {...ROUTES[ROUTE_NAMES.POLICYHOLDER]}>
        <Policyholder />
      </Route>
      <Route {...ROUTES[ROUTE_NAMES.UNDERWRITING]}>
        <Underwriting />
      </Route>
      <Route {...ROUTES[ROUTE_NAMES.VEHICLE_INFORMATION]}>
        <VehicleInformation />
      </Route>
    </Switch>
  );
};
